import React from 'react';

export function CloseIcon(props:React.SVGProps<SVGSVGElement>){
    return (
        <svg viewBox="0 0 64 64" {...props}>
        <path d="M54.5,45.7c0,1-0.4,1.9-1.1,2.6l-5.2,5.2c-0.7,0.7-1.6,1.1-2.6,1.1c-1,0-1.9-0.4-2.6-1.1L32,42.3L20.9,53.4
            c-0.7,0.7-1.6,1.1-2.6,1.1c-1,0-1.9-0.4-2.6-1.1l-5.2-5.2c-0.7-0.7-1.1-1.6-1.1-2.6c0-1,0.4-1.9,1.1-2.6L21.7,32L10.6,20.9
            c-0.7-0.7-1.1-1.6-1.1-2.6c0-1,0.4-1.9,1.1-2.6l5.2-5.2c0.7-0.7,1.6-1.1,2.6-1.1c1,0,1.9,0.4,2.6,1.1L32,21.7l11.1-11.1
            c0.7-0.7,1.6-1.1,2.6-1.1c1,0,1.9,0.4,2.6,1.1l5.2,5.2c0.7,0.7,1.1,1.6,1.1,2.6c0,1-0.4,1.9-1.1,2.6L42.3,32l11.1,11.1
            C54.1,43.8,54.5,44.7,54.5,45.7z"/>
        </svg>
    )
}